import { Shoteyes } from 'zf-types';
import { Col, Radio, Row, Space } from 'antd';
import { Block } from '../../../block';
import styles from '../style.module.less';
import { service } from '../service';
import { SelectStyleEnum } from '../types';
import type { ReactElement } from 'react';
import type { RadioBoxProps } from './types';

export function RadioBoxComponent(props: RadioBoxProps): ReactElement {
  const options: RadioBoxProps['option'][] = service.splitArray(props.option ?? [], 2);

  // 考试单独特殊显示
  if (props?.formType === Shoteyes.FormType.ANSWER) {
    return (
      <div className={styles.mb10}> {
        (props?.option ?? [])?.map((row, index) => (
          <Row key={index}>
            <Col span={12} key={`${row.value}_${row.title}`}>
              <div>{row.value}.{row.title}</div>
            </Col>
          </Row>
        ))}
      </div>
    );
  }
  return (
    <Radio.Group
      value={props.value}
      className={styles.radioGroup}
      onChange={event => props.onPropsChange?.({ value: event.target.value })}
    >
      <Block if={props.selectStyle === SelectStyleEnum.GRID}>
        {options.map((row, index) => (
          <Row key={index}>
            {row.map(col => (
              <Col span={12} key={`${col.value}_${col.title}`}>
                <Radio value={col.value}>
                  {col.title}
                </Radio>
              </Col>
            ))}
          </Row>
        ))}
      </Block>
      <Block
        if={[SelectStyleEnum.LINE, SelectStyleEnum.LIST].includes(props.selectStyle)}
      >
        <Space
          direction={
            props.selectStyle === SelectStyleEnum.LIST
              ? 'vertical'
              : 'horizontal'
          }
          wrap
        >
          {(props.option ?? []).map(item => (
            <Radio
              value={item.value}
              key={`${item.title}_${item.value}`}
            >
              {item.title}
            </Radio>
          ))}
        </Space>
      </Block>
      <Block if={props.selectStyle == null}>
        <Space direction="horizontal" wrap>
          {(props.option ?? []).map(item => (
            <Radio
              value={item.value}
              key={`${item.title}_${item.value}`}
            >
              {item.title}
            </Radio>
          ))}
        </Space>
      </Block>
    </Radio.Group>
  );
}
